import { render } from "./ConsultantLegacyImport.vue?vue&type=template&id=250dcda4"
import script from "./ConsultantLegacyImport.vue?vue&type=script&lang=js"
export * from "./ConsultantLegacyImport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__